import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_TOP_VIDEOS').plugin(axiosPlugin, {template: "array"});

let fetchUserTopVideosAction = redux.fetchActionGet();

export const fetchUserTopVideos = (userId, query = {}) => fetchUserTopVideosAction(`/users/${userId}/best-medias?${queryString.stringify(query)}`);
export const resetUserTopVideos = () => redux.actions.reset();

export const userTopVideos = redux.reducer();